/** Canonical account detail path — always encodes the id segment (e.g. distribution list emails). */
export function getAccountPath(accountId: string): string {
	const id = String(accountId ?? '').trim()
	if (!id) return '/accounts'
	return `/accounts/${encodeURIComponent(id)}`
}

export function getAccountStgPath(accountId: string): string {
	return `${getAccountPath(accountId)}/stg`
}
